import { css } from '@emotion/react'
import Link from 'next/link'
import Heart from 'assets/icons/heart.svg'
import { unifiedColors } from 'styles/colors'
import { styled } from 'styles/styled'
import { theme } from 'styles/theme'

export const CardContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  cursor: pointer;
`

export const ImageContainer = styled.div`
  border-radius: 16px;
  overflow: hidden;
  background: white;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px;
  position: absolute;
  z-index: 1;
  svg {
    position: relative;
    top: 0;
    right: 0;
  }
`

export const InstantBadge = styled.span`
  ${css({ ...theme.typography.bodyMSemiBold })}
  background-color: rgba(0, 0, 0, 0.5);
  color: ${unifiedColors.shadow.quaternary};
  padding: 2px 8px;
  border-radius: 12px;
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 192px;
`

interface HeartIconProps {
  $selected: boolean | undefined
  $absolute?: boolean
  $outlineHeart?: boolean
}

type Icon = React.FC<React.SVGAttributes<SVGElement>>

export const HeartIcon = styled(Heart as Icon, {
  shouldForwardProp: (prop) =>
    prop !== '$selected' && prop !== '$absolute' && prop !== '$outlineHeart'
})<HeartIconProps>`
  ${({ $absolute }) =>
    $absolute &&
    css`
      position: absolute;
      top: 20px;
      right: 20px;
    `}
  path {
    ${({ $selected, $outlineHeart }) =>
      $selected
        ? css`
            fill-opacity: 1;
            stroke: ${$outlineHeart
              ? unifiedColors.button.primary.default
              : theme.palette.surface.default};
            fill: ${unifiedColors.button.primary.default};
          `
        : css`
            stroke-opacity: 1;
            stroke: ${$outlineHeart
              ? theme.palette.label.default
              : theme.palette.surface.default};
            fill-opacity: 0.5;
            fill: ${$outlineHeart
              ? theme.palette.surface.default
              : theme.palette.label.default};
          `}
  }
`
